




import { Component, Vue } from 'vue-property-decorator';
import ProductGroupList from '@/components/ProductGroup/ProductGroupList.vue';

@Component({
  components: {
    ProductGroupList,
  },
})
export default class ProductGroups extends Vue {
}
